











import CommonBase from "@/components/CommonBase";
import {Component} from "vue-property-decorator";
import Userterms from "@/components/Userterms.vue";

@Component({
  components: {
    "at-userterms": Userterms
  }
})
export default class UsertermsPage extends CommonBase {

}

